import { allTimezones } from "react-timezone-select"

const timezoneBlacklist = [
	"Novosibirsk",
	"Yerevan",
	"Irkutsk",
	"Kamchatka",
	"Marshall Islands",
	"Krasnoyarsk",
	"Magadan",
	"Vladivostok",
	"Yakutsk",
	"Ekaterinburg",
	"Minsk",
	"Moscow",
	"St. Petersburg",
	"Volgograd",
]

export const timezones = {
	...Object.fromEntries(
		Object.entries(allTimezones).filter(([_, value]) => {
			return !timezoneBlacklist.some((city) => value.includes(city))
		}),
	),
	"Europe/Amsterdam": "Amsterdam, Rome, Stockholm",
	"Europe/Berlin": "Berlin",
}

export const dayOptions = [
	{ label: "Weekdays", value: "Weekdays" },
	{ label: "Weekends", value: "Weekends" },
	{ label: "Monday", value: "Monday" },
	{ label: "Tuesday", value: "Tuesday" },
	{ label: "Wednesday", value: "Wednesday" },
	{ label: "Thursday", value: "Thursday" },
	{ label: "Friday", value: "Friday" },
	{ label: "Saturday", value: "Saturday" },
	{ label: "Sunday", value: "Sunday" },
]

export const timeOptions = [
	{ label: "12:00 AM", value: "12:00 AM" },
	{ label: "1:00 AM", value: "1:00 AM" },
	{ label: "2:00 AM", value: "2:00 AM" },
	{ label: "3:00 AM", value: "3:00 AM" },
	{ label: "4:00 AM", value: "4:00 AM" },
	{ label: "5:00 AM", value: "5:00 AM" },
	{ label: "6:00 AM", value: "6:00 AM" },
	{ label: "7:00 AM", value: "7:00 AM" },
	{ label: "8:00 AM", value: "8:00 AM" },
	{ label: "9:00 AM", value: "9:00 AM" },
	{ label: "10:00 AM", value: "10:00 AM" },
	{ label: "11:00 AM", value: "11:00 AM" },
	{ label: "12:00 PM", value: "12:00 PM" },
	{ label: "1:00 PM", value: "1:00 PM" },
	{ label: "2:00 PM", value: "2:00 PM" },
	{ label: "3:00 PM", value: "3:00 PM" },
	{ label: "4:00 PM", value: "4:00 PM" },
	{ label: "5:00 PM", value: "5:00 PM" },
	{ label: "6:00 PM", value: "6:00 PM" },
	{ label: "7:00 PM", value: "7:00 PM" },
	{ label: "8:00 PM", value: "8:00 PM" },
	{ label: "9:00 PM", value: "9:00 PM" },
	{ label: "10:00 PM", value: "10:00 PM" },
	{ label: "11:00 PM", value: "11:00 PM" },
]
